import script from "./goRinSyo0084.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0084.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0084.vue?vue&type=style&index=0&id=0a057b00&lang=scss"

const __exports__ = script;

export default __exports__